var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcCareer = function SvgIcCareer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3474_621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7657 31.8323H1.53369V43.0643H12.7657V31.8323Z",
    fill: "#FF5347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7657 31.8323H1.53369V34.341H12.7657V31.8323Z",
    fill: "#FCD647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 22.8503H12.7681V43.0643H24.0001V22.8503Z",
    fill: "#049DDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 22.8503H12.7681V25.3591H24.0001V22.8503Z",
    fill: "#28DCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.232 13.9966H24V43.0643H35.232V13.9966Z",
    fill: "#00BF5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.232 13.9966H24V16.5053H35.232V13.9966Z",
    fill: "#07F184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 4.93579H35.2319V43.0665H46.4639V4.93579Z",
    fill: "#3B3BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 4.93579H35.2319V7.44454H46.4639V4.93579Z",
    fill: "#7161DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3474_621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcCareer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ic-career.89bb7d60992252763f2d8ddfc420f056.svg";